import { useQuery } from 'react-query';
import { api } from 'services/api';
import ICustomAxiosRequestConfig from 'services/custom/ICustomAxiosRequestConfig';

export const FIFTEEN_MINUTES_STALE = 1000 * 60 * 15;

export type Line = {
  id: string;
  unit_id: string;
  name: string;
  mobile: string;
  email: string;
  position: string;
  people: number;
  code: number;
  table: number;
  preferential: boolean;
  trackingUrl: string;
  info: string;
};

type UseLinesParams = {
  status?: string;
  sort?: string;
  per_page?: number;
} | null;

type GetLinesResponse = {
  status: number;
  data: Line[];
};

type GetLinesHeaders = {
  authorization: string;
};

export const getLines = async (
  params?: UseLinesParams,
  headers?: GetLinesHeaders,
  serverSide?: { serverSide: boolean }
): Promise<GetLinesResponse> => {
  const { status, data } = await api.get('/line/v1/lines', {
    params,
    headers,
    serverSide,
  } as ICustomAxiosRequestConfig);

  return {
    status,
    data: data.data,
  };
};

export const useLines = (params?: UseLinesParams) => {
  return useQuery('lines', () => getLines(params), {
    staleTime: FIFTEEN_MINUTES_STALE,
  });
};
